import { BaseApi } from '../../api/apiBase';

export interface Keyword {
  id: string;
  name: string;
  displayName: string;
}

export interface KeywordEvent {
  id: string;
  slug: string;
  name: string;
  description?: string;
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
  timeZone?: string;
  imageUrl?: string;
  publishedAt?: string;
  registrationInstructions?: string;
  agendaInstructions?: string;
  registrationState?: string;
  isRegistered?: boolean;
  team?: {
    id: string;
    name: string;
    eventName?: string;
  };
  location?: {
    id: string;
    name: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
  };
  keywords?: Keyword[];
}

export interface KeywordEventsResponse {
  events: KeywordEvent[];
  meta: {
    totalCount: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
}

interface KeywordEventsParams {
  keywordIds: string[];
  includePast?: boolean;
  limit?: number;
  offset?: number;
  search?: string;
}

class KeywordsApi extends BaseApi {
  constructor() {
    super('/api/portal');
  }

  async getKeywords(): Promise<Keyword[]> {
    return this.get<Keyword[]>('/keywords');
  }

  async getEventsByKeywords(params: KeywordEventsParams): Promise<KeywordEventsResponse> {
    const queryParams: Record<string, any> = {
      keyword_ids: params.keywordIds.join(',')
    };

    if (params.includePast !== undefined) {
      queryParams.include_past = params.includePast;
    }

    if (params.limit !== undefined) {
      queryParams.limit = params.limit;
    }

    if (params.offset !== undefined) {
      queryParams.offset = params.offset;
    }

    if (params.search !== undefined && params.search.trim() !== '') {
      queryParams.search = params.search;
    }

    // Use getWithMeta to retrieve both data and meta
    const { data, meta } = await (this as any).getWithMeta<KeywordEvent[]>('/keywords/events', queryParams);
    
    return {
      events: data || [],
      meta: meta || {
        totalCount: 0,
        limit: params.limit || 50,
        offset: params.offset || 0,
        hasMore: false
      }
    };
  }
}

export const keywordsApi = new KeywordsApi();